/**
 * vibrate — guarded wrapper around the Vibration API.
 * No-op on iOS (which silently ignores) and on browsers that don't expose it.
 * Use small durations only (8-30ms) so the device feels "responsive", not "alarmed".
 */
export function vibrate(pattern) {
  try {
    if (typeof navigator !== "undefined" && navigator.vibrate) {
      navigator.vibrate(pattern);
    }
  } catch {
    /* noop */
  }
}

// Preset durations tuned for a premium feel — keep them short.
export const HAPTICS = {
  TICK: 8,         // page swipe / tab change
  PULSE: 18,       // confidence trend chip first appearance
  SCORE_LAND: 30,  // rain confidence ring count-up reaches the target
};
